import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import DateSection from './formSections/date';
import DescriptionSection from './formSections/description';
import ShopSection from './formSections/shop';
import BrandSection from './formSections/brand';
import ImagesSection from './formSections/images';
import CheckboxesSection from './formSections/checkboxes';
import PricesSection from './formSections/prices';
import CommunicationsCheckboxes from './formSections/communicationsCheckboxes';
import { useTranslation } from 'react-i18next';
import useProducts from '../useProducts';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';
import FormHelper from 'helpers/FormHelper';

const EditProducts = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    handleApprove,
    singleItem,
    form,
    updateInProcess,
    handleCreateOrUpdate,
    handleDeleteFile,
    filterData,
  } = useProducts(false);

  const onFinish = async (params) => {
    await handleCreateOrUpdate(params);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('PUBBLICA PRODOTTO') : t('MODIFICA PRODOTTO');

  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            brand_id: '',
            company_id: '',
            title: '',
            price_retail: '',
            outlet_discount_price: '',
            outlet_price: '',
            discount: '',
            final_price: '',
            description: '',
            marketing_approved: false,
            retail_approved: false,
            date_from: '',
            date_to: '',
            hide_price: false,
            contractor_ids: [],
            is_archive: false,
            is_newsletter: false,
            is_radio: false,
            is_social: false,
            is_web: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection isView={isApproveOnly} form={form} />
          <DateSection isView={isApproveOnly} />
          <DescriptionSection isView={isApproveOnly} form={form} />
          <PricesSection isView={isApproveOnly} />
          <ImagesSection
            isView={isApproveOnly}
            updateInProcess={updateInProcess}
            handleDeleteFile={handleDeleteFile}
            singleItem={singleItem}
            isEdit={!isNew}
          />

          <ShopSection
            isView={isApproveOnly}
            shops={filterData.companies}
            inactiveShops={filterData.inactive_companies}
          />
          <BrandSection isView={isApproveOnly} brands={filterData.online_brands || []} />
          <CheckboxesSection data={singleItem} isView={isApproveOnly} />
          <CommunicationsCheckboxes isView={isApproveOnly} data={singleItem} />
          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  loading={updateInProcess}
                  icon={<CheckOutlined />}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
          {!isNew && (
            <NotificationFormForEdit
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_admin}
              showRefuse={!!singleItem.can_refuse}
              approveKey={'publish'}
              rejectKey={'unpublish'}
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default EditProducts;
